import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../login/AuthProvider";
import { dateHelper,  dateListCreator} from "../../modules/helpers";
import { report, annual_target } from '../../components/apipath';
import { motion } from "framer-motion"
import ChartLine from "../../components/chart_line"
import ChartColumn from "../../components/chart_column"

let reportSum = [];

function AdmReport() {
    const [reportSums, setReportSums] = useState([]);
    const [reportData, setReportDate] = useState();
    const [annualTarget, setReportAnnualTarget] = useState();
    const { token } = useAuth();
    const timeOptions = [
        { label: '7 天', value: '7d' },
        { label: '30 天', value: '30d' },
        { label: '一季', value: '3M' },
        { label: '一年', value: '1y' },
      ];

    const [rangeMap, setRangeMap] = useState([
        '7d',  // CPA
        '30d', // CMA
        '6M',  // CPE
        '1y',  // Score
        '7d',  // CPA 專業
        '30d', // CPA 全修
        '6M',  // CPA 選修
        '1y',  // CPA 自修
      ]);

      const data = [
        { index: 0, title: "CPA 報名人數", type: "column" },
        { index: 1, title: "CMA 報名人數", type: "column" },
        { index: 2, title: "CMA 菁英方案", type: "column" },
        { index: 3, title: "CMA 自修方案", type: "column" },
        { index: 4, title: "成績單評估人數", type: "column" },
        { index: 5, title: "CPA 專業方案", type: "column" },
        { index: 6, title: "CPA 全修方案", type: "column" },
        { index: 7, title: "CPA 選修方案", type: "column" },
        { index: 8, title: "CPA 自修方案", type: "column" },
        { index: 9, title: "CPA 單科雙語", type: "column" },
      ];
      

      const getUserName = () => {
        const auth = JSON.parse(localStorage.getItem('authAdm'));
        return auth?.name || auth?.chinese_name || "使用者";
    };

    const isEmptyDict = (obj) => {
        return Object.keys(obj).length === 0;
    }

    const roundTo = ( num, decimal ) => { 
        return Math.round( ( num + Number.EPSILON ) * Math.pow( 10, decimal ) ) / Math.pow( 10, decimal ); 
    }

    const dataMaker = (data, dateRange) => {
        let newData = [];
        let sum = 0;
        for(let i in dateRange){
            newData.push({x: parseInt(i), y: 0});
            for(let j in data){
                if (dateHelper(data[j].x, 'date') === dateRange[i]) {
                    newData[i].y = (data[j].y === 0 ? 0.001 : data[j].y);
                    sum = sum + parseInt(data[j].y);
                }
            }
        }
        reportSum.push(sum);
        return newData;
    }

    const fetchReportData = async () => {
        // 把 rangeMap 的參數組成 query string
        const queryString = rangeMap.map((val, idx) => `range${idx}=${val}`).join("&");
        const response = await axios.get(`${report}?${queryString}`, {
            headers: { token: token },
        });
        setReportDate(response.data);
    };

    useEffect(() => {
        if (reportData) {
            const newSums = reportData.map((item, i) => {
                const chartData = dataMaker(item, dateListCreator(rangeMap[i]));
                const total = chartData.reduce((acc, cur) => acc + parseInt(cur.y), 0);
                return total;
            });
            setReportSums(newSums);
        }
    }, [reportData, rangeMap]);

    useEffect(() => {
        fetchReportData();
    }, [rangeMap]);


    const fetchAnnualTarget = async ()=> {
        const response = await axios.get(`${annual_target}${new Date(Date.now()).getFullYear()}`);
        setReportAnnualTarget(response.data.data[0]);
    }
    useEffect(()=>{
        fetchAnnualTarget();
    }, []);
      
    const handleAnnualTargetChange = async(e) =>{
        const {  value   } = e.target;
        if (e.key === 'Enter') {
            const newData = {
                annual: new Date().getFullYear(),
                target: value,
                complete_total: value,
                complete: (parseInt(value) >= parseInt(annualTarget.target) ? 1:0)
            }
            try {
                const pattern = /^[1-9][0-9]*$/igm;
                if(!pattern.test((value+""))){
                    alert("年度目標必須是正整數!");
                    return false;
                } else {
                    let _confirm = window.confirm("是否修改年度目標 ?");
                    if(_confirm){
                        const response = await axios.put(annual_target, newData, {headers: {
                            Authorization: `Bearer ${token}`,
                            token: token
                        }});
                        fetchAnnualTarget();
                    }
                }
            } catch (error) {
                alert(error);
            }
        }
    }

    return (
        <>
            {/* <!-- banner --> */}
            <div className="beckerbanner">
                <div className="beckerbannerblock col-4">
                    <div className="wlecomsign">
                        <div className="lgtext">Welcome</div>
                        <div className="beclertitle">{getUserName()}</div>
                        Thank you for your contribution<br />
                        to Direct Line<br />
                    </div>
                </div>
                <motion.div
                        initial={{ opacity: 0, x:100 }}
                        whileInView={{ opacity: 1, x:0 }}
                        transition={{
                        delay: 0.4,
                        default: { ease: "linear" },
                    }}>
                    <div className="col-10">
                        <img src="/admImg/welcomepic.jpg" alt=""/>
                    </div>
                </motion.div>
            </div>
            <div className="w-75 m-5 mx-auto">
                <div className="row g-5 justify-content-center">
                {reportData && data.map((item, i) => (
                    <div key={i} className="col-xl-4 col-md-6 col-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="row g-1">
                                <div className="col-6 fw-bold">{item.title}</div>
                                <div className="col-6 text-end">
                                    <select
                                    className="form-select form-select-sm"
                                    value={rangeMap[i]}
                                    onChange={(e) => {
                                        const updatedRange = [...rangeMap];
                                        updatedRange[i] = e.target.value;
                                        setRangeMap(updatedRange);
                                    }}
                                    >
                                    {timeOptions.map(opt => (
                                        <option key={opt.value} value={opt.value}>
                                        {opt.label}
                                        </option>
                                    ))}
                                    </select>
                                </div>
                                <div className="col-8 text-start">
                                    {item.type === "line"
                                    ? new ChartLine().render(dataMaker(reportData[i], dateListCreator(rangeMap[i])))
                                    : new ChartColumn().render(dataMaker(reportData[i], dateListCreator(rangeMap[i])))
                                    }
                                </div>
                                <div className="col-4 text-center">
                                    <span style={{ fontSize: "60px" }}>
                                    {reportSums[i]}
                                    </span>人
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    ))}
                    <div className="col-xl-4 col-md-6 col-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="row g-1">
                                    <div className="col-12 fw-bold">年度業績目標</div>
                                    <div className="col-12 text-center">
                                        <div className="d-flex align-items-center" style={{fontSize: "60px"}}>
                                            <div className="col-5">{reportData && (reportData[8][0].total)} <span className="ms-1 me-1">人/</span></div>
                                            {annualTarget ? (
                                            <div className="">
                                                <input
                                                type="text"
                                                style={{ width: "110px", fontSize: "60px" }}
                                                defaultValue={annualTarget.target}
                                                onKeyUp={handleAnnualTargetChange}
                                                />
                                                <span style={{ fontSize: "60px", marginLeft: "10px" }}>人</span>
                                          </div>
                                            ) : (
                                            <div>載入中...</div>
                                            )}
                                        </div>
                                        <div className="progress" role="progressbar" aria-label="Basic example" aria-valuenow={reportData && ((parseFloat(reportData[8][0].total) / parseFloat(annualTarget.target)) * 100.0)} aria-valuemin="0" aria-valuemax="100">
                                            <div className="progress-bar" style={{width: (reportData && ((parseFloat(reportData[8][0].total) / parseFloat(annualTarget.target)) * 100.0) + "%")}}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6 col-12 mb-5">
                        <div className="card">
                            <div className="card-body">
                                <div className="row g-1">
                                    <div className="col-12 fw-bold">月營業額</div>
                                    <div className="col-12 text-center">
                                        <span style={{fontSize: "60px"}}>
                                            ${reportData && (roundTo(reportData[9][0].total/1000.0, 1))}k
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6 col-12 mb-5">
                        <div className="card">
                            <div className="card-body">
                                <div className="row g-1">
                                    <div className="col-12 fw-bold">季營業額</div>
                                    <div className="col-12 text-center">
                                        <span style={{fontSize: "60px"}}>
                                            ${reportData && (roundTo(reportData[10][0].total/1000.0, 1))}k
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6 col-12 mb-5">
                        <div className="card">
                            <div className="card-body">
                                <div className="row g-1">
                                    <div className="col-12 fw-bold">年營業額</div>
                                    <div className="col-12 text-center">
                                        <span style={{fontSize: "60px"}}>
                                            ${reportData && (roundTo(reportData[11][0].total/1000.0, 1))}k
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </>
    );
}
export default AdmReport;